/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Step value
 */
export interface StepDto { 
    turn?: number;
    phase?: StepDto.PhaseEnum;
}
export namespace StepDto {
    export type PhaseEnum = 'StartOfTurn' | 'Trade' | 'CityManagement' | 'Movement' | 'Research';
    export const PhaseEnum = {
        StartOfTurn: 'StartOfTurn' as PhaseEnum,
        Trade: 'Trade' as PhaseEnum,
        CityManagement: 'CityManagement' as PhaseEnum,
        Movement: 'Movement' as PhaseEnum,
        Research: 'Research' as PhaseEnum
    };
}